module.exports = __webpack_public_path__ + "img/nissin-4.bb2bd9b5.jpg";